import { Tabs } from '@design-systems/canvas-ui'
import { MPMLayout } from 'components/layout/layout'
import { PageTabs } from 'components/page-tabs'
import { TRANSLATION_KEYS } from 'locales/translation-keys'
import { ErrorBoundary } from 'react-error-boundary'
import { ErrorFallback } from 'components/error-fallback'
import { useMemo } from 'react'
import { isStore } from 'utils/location'
import { useEssentials } from 'hooks/utils/useEssentials'
import { useLogClick } from 'utils/analytics'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

export const TrailerPage = () => {
    const { t, currentLocation } = useEssentials()
    const { trailer } = TRANSLATION_KEYS
    const { tabs: tabsKeys } = trailer
    const navigate = useNavigate()
    const { pathname, search } = useLocation()
    const { logClick } = useLogClick('trailer')

    const tabsWithTranslations = useMemo(() => {
        return [
            { key: 'summary', label: t(tabsKeys.summary) },
            { key: 'schedule', label: t(tabsKeys.schedule) },
        ]
    }, [t, tabsKeys])

    const currentPath = pathname.split('/').pop() || 'summary'
    // Ensure activeTab is always 'summary' or 'schedule', never 'trailer' during redirects
    const activeTab =
        currentPath === 'trailer' || currentPath === ''
            ? 'summary'
            : currentPath

    const handleTabSelect = (activeTab: string) => {
        logClick('trailer tab ' + activeTab)
        void navigate(`/trailer/${activeTab}${search}`)
    }
    return (
        <ErrorBoundary
            fallbackRender={({ error, resetErrorBoundary }) => (
                <ErrorFallback
                    error={error}
                    resetErrorBoundary={resetErrorBoundary}
                    heading={t(trailer.title)}
                />
            )}
        >
            <MPMLayout
                heading={t(trailer.title)}
                className={isStore(currentLocation) ? 'hc8-ph-none' : ''}
                hasTabs={isStore(currentLocation)}
                tabs={
                    isStore(currentLocation) && (
                        <PageTabs
                            activeTab={activeTab}
                            className="tabs hc8-pv-2x"
                            disableAdaptive={true}
                            onTabSelect={handleTabSelect}
                        >
                            {tabsWithTranslations.map((tab) => (
                                <Tabs.Item key={tab.key} name={tab.key}>
                                    {tab.label}
                                </Tabs.Item>
                            ))}
                        </PageTabs>
                    )
                }
            >
                {isStore(currentLocation) ? (
                    <div className="hc8-ph-4x">
                        <Outlet />
                    </div>
                ) : (
                    <Outlet />
                )}
            </MPMLayout>
        </ErrorBoundary>
    )
}
